module.exports = __webpack_public_path__ + "static/media/avatar.04b2fe7c.png";